import { h, Fragment, render } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { initialSessionFromDom, useSubmission } from './../hooks/useSubmission'

import { json } from './../utility/dom'
import { scrollTo } from './../utility/scrollTo'

import { Checkbox } from './../components/Checkbox'
import { FieldBasic } from './../components/FieldBasic'
import { FieldContainer } from './../components/FieldContainer'
import { FieldSelect } from './../components/FieldOptions'
import { SubmitButton } from './../components/SubmitButton'
import { ExpiryCounter } from './../components/ExpiryCounter'

export function init() {
	const eventFormEl = document.getElementById('event-form')
	const programmeId = eventFormEl?.getAttribute('data-programme-id')
	const session = initialSessionFromDom()
	const stages = json('#form-stages')

	eventFormEl && render(
		createPortal(<EventForm programmeId={programmeId} session={session} stages={stages} />, eventFormEl),
		document.body
	)
}


function EventForm({ programmeId, session, stages }) {

	const beforeSubmit = data => {
		
		// submit the question alongside the answer
		session.eventAdditionalQuestions.map(({ question }, i) => {
			data[`EventAdditionalQuestion${i + 1}Question`] = question
		})

		data['EventName'] = session.eventName || ''

		return {
			...data,
			Stage: 'complete',
			GdprTime: (new Date()).toISOString(),
			GdprUseIP: true,
		}
	}
	
	const onSuccess = () => {
		window.location = stages.success
	}
	const onError = () => {
		setTimeout(() => {
			const el = document.querySelector('[class*="error"]')
			el && scrollTo(el, -80)
		}, 20)
	}

	const { 
		fields, expires, validation, processing, submitted, 
		onSubmitComplete, onInput, onInputDebounced, extendSession,
	} = useSubmission({ session, beforeSubmit, onSuccess, onError })

	const titleOptions = ['Mr', 'Mrs', 'Miss', 'Ms', 'Mx', 'Captain', 'Professor', 'Doctor', 'Dame', 'Lady', 'Lord', 'Sir', 'Baroness', 'Baron']

	return <>
		<form onSubmit={onSubmitComplete}>
			<input name="Type" type="hidden" value="event" />
			<div class="bg--white text-fade box-padding rounded border--lightgrey margin-bottom-5 first-last">
				<h2 class="heading-4">Please share your details below</h2>

			    <h2 class="heading-5 margin-top-4">Your details</h2>
		    	<FieldSelect class="select--autowidth" name="Title" label="Title" value={fields.Title} options={titleOptions} onChange={onInput} error={validation.Title} />
		    	<FieldBasic name="Name" type="text" label="Full name" placeholder="Enter your full name" autocomplete="name" value={fields.Name} onChange={onInputDebounced} onBlur={onInput} error={validation.Name} />
			    <FieldBasic name="Email" type="email" label="Email address" placeholder="e.g. email@domain.com" value={fields.Email} onBlur={onInput} error={validation.Email} />
			    {/*<FieldBasic name="Phone" type="tel" label="Phone number" placeholder="Enter your phone number" value={fields.Phone} onBlur={onInput} error={validation.Phone} />*/}
			    <FieldBasic name="CurrentPosition" label="Current position" value={fields.CurrentPosition} onBlur={onInput} error={validation.CurrentPosition} />
			    <FieldBasic name="CurrentOrganisation" label="Current organisation" description="Please use official company name, or former company name" value={fields.CurrentOrganisation} onBlur={onInput} error={validation.CurrentOrganisation} />

			    <hr class="box-separator" />

			    {session.eventAdditionalQuestions.length && <>
				    <FieldContainer>
			        	<h2 class="heading-5">Additional questions</h2>
			        	{session.eventAdditionalQuestions.map((question, i) => {
			        		const id = `EventAdditionalQuestion${i + 1}`
			        		return <>
			        			<FieldBasic name={id} type="text" label={question.question} value={fields[id]} onChange={onInputDebounced} onBlur={onInput} error={validation[id]} />
			        		</>
			        	})}
			        </FieldContainer>
			        <hr class="box-separator" />
		        </> || ''}		        

		    	<FieldContainer error={validation.Gdpr}>
		    	    <h2 class="heading-5">Your data</h2>
		    	    <div class="last margin-bottom-2" dangerouslySetInnerHTML={{ __html : session.gdprText}}></div>
		    	    {session.howWeUseYourData && <>
		    	    	<details class="margin-top-2 margin-bottom-4 text-main">
		    	    		<summary>How we use your data</summary>
		    	    		<div dangerouslySetInnerHTML={{ __html : session.howWeUseYourData}}></div>
		    	    	</details>
		    	    </>}
		    	    <input name="GdprText" type="hidden" value={session.gdprText} />
		    	    <Checkbox name="Gdpr" value="true" label="I agree" large button checked={fields.Gdpr} onChange={onInput} />
		        </FieldContainer>

		        <SubmitButton class="button button--fill button--yellow margin-top-4" processing={processing || submitted}>
		        	{(processing || submitted) && 'Processing' || 'Submit'}
		        </SubmitButton>
			</div>

			<ExpiryCounter expires={expires} onExtend={extendSession} />
		</form>
	</>
}